import { useQuery } from '@tanstack/react-query';
import { getCustomers } from '../services/customerService';
import { queryKeys } from '../constants/queryKeys';

const PAGE_SIZE = 20;

// Fetch paginated customer list — returns the raw envelope { data, totalPages, ... }
export const useCustomers = (page = 1, search = '', customerId = '', salesMode = '', reminderMonth = '') => {
  return useQuery({
    queryKey: queryKeys.customers.list(page, search, customerId, salesMode, reminderMonth),
    queryFn: () => getCustomers({
      page,
      pageSize: PAGE_SIZE,
      search: search || undefined,
      customerId: customerId || undefined,
      salesMode: salesMode || undefined,
      reminderMonth: reminderMonth || undefined,
    }),
  });
};
